import { createFileRoute } from '@tanstack/react-router';
import { CountReviewPage } from '@/features/stock/count-review-page';

export const Route = createFileRoute('/_app/stock/counts/$countNo')({
  // W-09 takes no search params: its two dialogs are decisions in progress, and a
  // link that reopens a confirmation nobody asked for is a trap (§0)
  component: function CountReview() {
    return <CountReviewPage countNo={Route.useParams().countNo} />;
  },
});
